(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallResultGroup', PhoneCallResultGroup);

    PhoneCallResultGroup.$inject = ['$resource'];

    function PhoneCallResultGroup ($resource) {
        var resourceUrl =  'api/phone-call-result-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
